import { SortCalendarDescendingIcon } from './SortCalendarDescendingIcon';

/**
 * author: Austin Andrews
 * id D01B3C7C-64DC-4486-A656-55F7024C96AA
 * name sort-calendar-descending
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sort-calendar-descending.svg
 * tags
 * - Text / Content / Format 
 * - Date / Time 
 */
export const SortDateDescendingIcon = SortCalendarDescendingIcon;
export default SortDateDescendingIcon